export const MUST_CHANGE_PASSWORD_KEY = "mustChangePassword";
export const POST_LOGIN_CONTEXT_KEY = "postLoginContext";

export function storePostLoginContext(data = {}) {
  sessionStorage.setItem(
    POST_LOGIN_CONTEXT_KEY,
    JSON.stringify({
      role_name: data.role_name,
      is_user: data.is_user,
      startup_info: data.startup_info,
      redirect_url: data.redirect_url,
    }),
  );
}

export function readPostLoginContext() {
  try {
    const raw = sessionStorage.getItem(POST_LOGIN_CONTEXT_KEY);
    return raw ? JSON.parse(raw) : {};
  } catch {
    return {};
  }
}

export function clearMustChangePasswordState() {
  localStorage.removeItem(MUST_CHANGE_PASSWORD_KEY);
  sessionStorage.removeItem(POST_LOGIN_CONTEXT_KEY);
}

export function markMustChangePasswordRequired(data = {}) {
  storePostLoginContext(data);
  localStorage.setItem(MUST_CHANGE_PASSWORD_KEY, "1");
}

export function mustChangePasswordPending() {
  return localStorage.getItem(MUST_CHANGE_PASSWORD_KEY) === "1";
}

function resolveDashboardPath(roleName) {
  switch (roleName) {
    case "jury_member":
      return "/dashboard/jury_member";
    case "startup_founder":
      return "/dashboard/startup_founder";
    case "center_admin":
      return "/dashboard/center_admin";
    case "superadmin":
      return "/dashboard/superadmin";
    case "mentor":
      return "/dashboard/mentor";
    default:
      // Custom center-defined designations (e.g. "Design Manager") are center
      // staff, not founders — land them in the center context, not the startup
      // founder dashboard.
      return "/dashboard/center_admin";
  }
}

export function navigateAfterLogin(data, navigate, options = {}) {
  const { toast, toastId, successMessage } = options;

  if (data.must_change_password) {
    markMustChangePasswordRequired(data);
    navigate("/set-password");
    return;
  }

  navigateToAppDestination(data, navigate, { toast, toastId, successMessage });
}

export function navigateToAppDestination(data, navigate, options = {}) {
  const { toast, toastId, successMessage } = options;
  const context = {
    role_name: data.role_name,
    is_user: data.is_user,
    startup_info: data.startup_info,
    redirect_url: data.redirect_url,
    ...readPostLoginContext(),
  };

  if (context.role_name === "startup_founder" && context.is_user === "new_user") {
    const startupId = context.startup_info?.startup_id;
    if (startupId) {
      if (toast && successMessage) {
        toast.success(successMessage, { toastId });
      }
      navigate(`/startup-registration?startupId=${startupId}&fromLogin=true`);
      return;
    }
  }

  let redirectUrl = context.redirect_url || resolveDashboardPath(context.role_name);
  if (context.role_name === "startup_founder") {
    redirectUrl = "/dashboard/startup_founder";
  }

  const postLoginRedirect = localStorage.getItem("post_login_redirect");
  if (postLoginRedirect) {
    localStorage.removeItem("post_login_redirect");
    if (toast && successMessage) {
      toast.success("Logged in! Redirecting…", { toastId });
    }
    navigate(postLoginRedirect);
    return;
  }

  if (toast && successMessage) {
    toast.success(successMessage, { toastId });
  }
  navigate(redirectUrl);
}
